export class AlterarSenha {

    public senhaAntiga: string;
    public senhaNova: string;
    public senhaConfirmacao: string;

   
    constructor(){ }
}


// WEBPACK FOOTER //
// ./src/app/gerenciador/dashboard/alterar-senha/shared/alterarSenha.ts